export default "__VITE_ASSET__Bf9cradF__"